<template>
  <div class="pocket-wrap" :class="{ 'pocket-wrap-dark': skinModel == '1' }">
    <div v-if="changeList.length" class="pocket-list-wrap">
      <div class="pocket-item" v-on:click="goDetail(item.detailId, item.changeType)" v-for="item in changeList">
        <div class="pocket-remark">
          <span class="remark">{{ item.tradeDesc }}</span>
          <span class="time">{{ item.tradeTime }}</span>
        </div>
        <div class="pocket-amount" :class="{ plus: item.accountType == 1, minus: item.accountType == 2 }">
          <b v-if="item.accountType == 1">+</b>
          <b v-if="item.accountType == 2">-</b>
          <span>{{ item.amount | amount_convert }}</span>
        </div>
      </div>
      <div class="pull-info" v-if="!bottom">加载更多...</div>
    </div>
    <div v-else class="pocket-empty">
      {{ text }}
    </div>
    <div class="bottom-info" v-if="changeList.length && bottom">已加载全部</div>
    <div v-if="loading" class="spinner-wrap">
      <div class="snake-wrap">
        <mt-spinner type="triple-bounce"></mt-spinner>
      </div>
    </div>
    <scroll v-on:onBottom="onBottom"></scroll>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import Scroll from "components/plugin/scroll";
import encrypt from "components/plugin/lib/encrypt.js";

Vue.filter("amount_convert", function (val) {
  return (val / 100).toFixed(2);
});

export default {
  components: {
    Scroll,
  },
  data() {
    return {
      loading: 0,
      changeList: [],
      lastRowId: "",
      pageRows: 20,
      bottom: 0,
      ddtoken: "",
      userId: "",
      circleId: "",
      ownerType: "",
      ownerId: "",
      text: "暂无零钱明细",
      skinModel: "0",
    };
  },
  beforeRouteEnter(to, from, next) {
    let skinModel = to.query.skinModel;
    next((vm) => {
      if (!to.query.ddtoken || !to.query.userId) return;
      if (to.query.ownerType) {
        vm.ownerType = to.query.ownerType;
        vm.ownerId = to.query.ownerId;
        vm.text = "暂无明细";
      }
      vm.ddtoken = to.query.ddtoken;
      vm.userId = to.query.userId;
      vm.circleId = to.query.circleId || "";
      vm.skinModel = skinModel;
      vm.getPage();
    });
  },
  methods: {
    getPage() {
      this.loading = 1;

      var params = {
        userId: this.userId,
        pageRows: this.pageRows,
        lastRowId: this.lastRowId,
        ddtoken: decodeURIComponent(this.ddtoken),
      };

      if (this.ownerType) {
        params.ownerType = this.ownerType;
        params.ownerId = this.ownerId;
      }

      if (this.ownerType == '3') {
        document.title = '余额明细'
      } else {
        document.title = '零钱明细'
      }

      if (this.circleId) {
        params.circleId = this.circleId;
      }

      this.$http
        .get("/pay/v1/change/list", {
          params: encrypt(params),
        })
        .then((res) => {
          if (res.body.status != 1) return;

          //数据加载完成
          if (!res.body.data.changeList.length) {
            this.loading = 0;
            this.bottom = 1;
            return;
          }

          var changeList = res.body.data.changeList;
          this.lastRowId = changeList[changeList.length - 1].rowId;
          this.changeList = this.changeList.concat(changeList);
          this.loading = 0;

          //数据加载的条数少于一页，表示数据加载完成
          if (changeList.length < this.pageRows) {
            this.bottom = 1;
          }
        });
    },
    onBottom() {
      //第一页都不够的话，直接不去加载
      if (this.changeList.length < this.pageRows || this.bottom) {
        this.bottom = 1;
        return;
      }

      if (!this.loading) {
        this.getPage(this.lastRowId);
      }
    },
    goDetail(id, changetype) {
      let query = {
        userId: this.userId,
        ddtoken: this.ddtoken,
        tradeId: id,
        changeType: changetype,
        circleId: this.circleId,
        skinModel: this.skinModel
      };
      if (this.ownerType == 2 || this.ownerType == 3) {
        query.ownerType = this.ownerType;
        query.ownerId = this.ownerId;
      }
      const urlSearchParams = new URLSearchParams(query).toString();
      window.location.href = `${window.location.origin}/webpay/pocket/detail?${urlSearchParams}`
      // this.$router.push({
      //   name: "PocketDetail",
      //   query,
      // });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~assets/lib/mixin";

.pocket-wrap {
  .pocket-list-wrap {
    .pocket-item {
      padding: 0 15px;
      height: 70px;
      .flex();
      .justify-content(space-between);
      .align-items(center);
      .setLine('bottom', @lineColor);

      // border-bottom: 1px solid @lineColor;
      &:active {
        background: #dee0e7;
      }

      .pocket-remark {
        .flex();
        .flex-direction(column);

        .remark {
          font-size: 15px;
          color: #333333;
        }

        .time {
          font-size: 14px;
          color: #888888;
        }
      }

      .pocket-amount {
        font-size: 19px;

        &.plus {
          color: @mainColor;
        }

        &.minus {
          color: #000000;
        }
      }
    }
  }

  .pocket-empty {
    margin-top: 190px;
    text-align: center;
    font-size: 19px;
    color: #cccccc;
  }

  .pull-info {
    text-align: center;
    color: #999;
    padding: 10px 0;
  }

  .bottom-info {
    text-align: center;
    color: #999;
    padding: 10px 0 20px 0;
  }
}

.pocket-wrap-dark {
  .pocket-list-wrap {
    .pocket-item {
      .setLine('bottom', #242424);
      // border-bottom: 1px solid #242424;
      background-color: #191919;

      &:active {
        background: #191919;
      }

      .pocket-remark {
        .remark {
          color: #D1D1D1;
        }

        .time {
          color: #5D5D5D;
        }
      }

      .pocket-amount {
        &.plus {
          color: @mainColor;
        }

        &.minus {
          color: #D1D1D1;
        }
      }
    }
  }

  .pocket-empty {
    color: #5D5D5D;
  }

  .pull-info {
    color: #8B8B8B;
  }

  .bottom-info {
    color: #8B8B8B;
  }
}

.spinner-wrap {
  .snake-wrap {
    width: 28px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/pocket/index.vue